import { MapPin } from 'lucide-react';
import { WinchStartPointManager } from '@/components/winch/WinchStartPointManager';

/**
 * WinchStartPointPage Component
 * Page for managing winch service base locations (start points)
 * Restricted to managers only
 */
export const WinchStartPointPage = () => {
  return (
    <div className="space-y-6" dir="rtl">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <MapPin className="h-8 w-8 text-primary" />
          <div>
            <h1 className="text-2xl font-bold text-primary">نقاط بداية الونش</h1>
            <p className="text-sm text-gray-400 mt-1">
              إدارة نقاط البداية المستخدمة لحساب مسافات خدمة الونش
            </p>
          </div>
        </div>
      </div>

      {/* Manager Component */}
      <WinchStartPointManager />
    </div>
  );
};

export default WinchStartPointPage;
